import { TExtraField } from './ExtraField'

export interface TAbstractCatalogConfig {
  id: string
  name: string
  extraId: string
  businessIdList: string[]
  networkIdList: string[]
  acl: IAcl[]
  active: boolean
  fields: TExtraField[]
}

export interface IAcl {
  profileID: string
  permissions: PERMISSIONS[]
}

export const ACL_OTHER = 'other'

export enum PERMISSIONS {
  CREATOR = 'creator',
  CATALOG_READ = 'catalog_read',
  CATALOG_UPDATE = 'catalog_update',
  CATALOG_DELETE = 'catalog_delete',
  ITEM_UPDATE = 'item_update',
  ITEM_DELETE = 'item_delete',
  BINDING = 'binding',
}
